import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { catchError, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { isCuentaInformacionApiUrl, isCuentasFeatureRoute } from '../utils/cuenta-informacion-api-url';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(AuthService);
  const router = inject(Router);

  if (
    req.url.includes('/api/login') ||
    req.url.includes('/api/auth/google') ||
    req.url.includes('/api/sso') ||
    req.url.includes('/assets')
  ) {
    return next(req);
  }

  if (auth.isTokenExpired()) {
    auth.logoutDueToExpiredToken(router.url);
    return throwError(() => new Error('Token expirado'));
  }

  const token = auth.getToken();

  if (token) {
    req = req.clone({
      setHeaders: { Authorization: `Bearer ${token}` },
    });
  }
  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401) {
        auth.logoutDueToExpiredToken(router.url);
      } else if (error.status === 403 && auth.isLoggedIn()) {
        const enCuentas = isCuentasFeatureRoute(router.url);
        const esInformacionCuenta = isCuentaInformacionApiUrl(req.url);
        const debeMostrarPagina403 = !enCuentas || esInformacionCuenta;
        if (debeMostrarPagina403) {
          void router.navigateByUrl('/403', { skipLocationChange: true });
        }
      }

      return throwError(() => error);
    }),
  );
};
